import { App } from 'vue';
import { get as _get } from "lodash";

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $setErrorsFromResponse: (errorResponse: any) => void;
        __: (key: string, bindings?: any) => string;
        assignJSONObject: (from: any, to: any) => any;
        asset: (path: string) => string;
    }
}

export default {
    install(app: App) {
        app.config.globalProperties.$setErrorsFromResponse = function (errorResponse) {
            if (!Object.prototype.hasOwnProperty.call(this, '$validator') || !errorResponse) {
                console.log("nothing");
                return;
            }
            console.log(Object.prototype.hasOwnProperty.call(this, '$validator'), "here");

            const keys = Object.keys(errorResponse);

            if (keys.length === 0) {
                return;
            }

            this.$ref.form.reset();

            const errorFields = [];
            keys.forEach(field => {
                if (field.indexOf(".") > -1) {
                    // Reconstruct the original field name. ex. 'urls[]'
                    const fieldOriginalName = `${field.split(".")[0]}[]`;
                    // If we don't have it in the resultant error fields, add it, otherwise
                    // only push the error as an array to the original response object.
                    if (!errorFields[fieldOriginalName]) {
                        errorFields.push(fieldOriginalName);
                        errorResponse[fieldOriginalName] = [errorResponse[field]]
                    } else {
                        errorResponse[fieldOriginalName].push(errorResponse[field]);
                    }
                } else {
                    // Otherwise just add it to the list.
                    errorFields.push(field);
                }
            });

            errorFields.forEach(field => {
                const errorValue = errorResponse[field];
                const errorString = errorValue instanceof Array ? errorValue.join(', ') : errorValue;
                //this.$validator.errors.add({field: field, msg: errorString});
            });
        };

        app.config.globalProperties.__ = (key: string, bindings?: any) => {
            if (!window.l) {
                throw "No localization in window variable.";
            }

            let translation = _get(window.l, key);

            if (translation && bindings) {
                for (const key in bindings) {
                    const value = bindings[key];
                    translation = translation.replace(`:${key}`, value);
                }
            }

            return translation;
        };

        app.config.globalProperties.assignJSONObject = (from: any, to: any) => {
            for (const key in from) {
                if (Object.prototype.hasOwnProperty.call(from, key)) {
                    to[key] = from[key];
                }
            }
            return to;
        };

        app.config.globalProperties.asset = (path: string) => {
            if (!window.v.cdn) {
                return `//www.venngo.com/${path}`;
            }

            if (window.v.cdn[window.v.cdn.length - 1] === "/") {
                window.v.cdn = window.v.cdn.slice(0, -1)
            }

            return window.v.cdn + path;
        };

        app.mixin({
            data() {
                return {
                    hasError(name: string) {
                        if (this["errors"]) {
                            return this["errors"].first(name) || false;
                        }
                        return false;
                    },
                };
            },
            created() {
                // TODO: vee-validate v4 has different localization API
                // This will need to be updated when we migrate vee-validate
                // localize(defaultDict);
                // localize(window.l.locale);
            }
        });
    }
};